module.exports = __webpack_public_path__ + "static/media/tick.07beca7f.svg";